export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
          关于51漫画网
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto">
          51漫画网成立于漫画阅读需求不断增长的时代，致力于为漫迷打造一个安全、稳定、高清的在线阅读平台。
          作为51漫画网站的官方入口，我们汇聚了来自国内外的优质漫画资源，涵盖热血、恋爱、奇幻、悬疑、搞笑、科幻等数十种分类，
          每日同步更新最新连载。平台支持51漫画网页版直接访问，无需下载即可畅享流畅阅读体验；
          同时也提供51漫画官网版与移动端适配方案，让您随时随地沉浸于精彩的漫画世界。
          我们的团队持续优化阅读体验，保障访问安全，立志成为漫迷心中最值得信赖的51漫画主页。
        </p>
      </div>
    </section>
  );
}